import type { RouteRecordRaw } from 'vue-router';

export const academicCalendarRoute: RouteRecordRaw = {
  path: '/academic-calendar',
  name: 'AcademicCalendar',
  component: () => import('./pages/TemplatesPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:study-periods:list'),
  },
};

export const academicCalendarYearsRoute: RouteRecordRaw = {
  path: '/academic-calendar/years',
  name: 'AcademicCalendarYears',
  component: () => import('./pages/AcademicYearsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:study-periods:list'),
  },
};

export const academicCalendarOverviewRoute: RouteRecordRaw = {
  path: '/academic-calendar/overview',
  name: 'AcademicCalendarOverview',
  component: () => import('./pages/OverviewPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:study-periods:list'),
  },
};
